<template>
    <div id="data-list-thumb-view" class="data-list-container">

      <vs-popup title="Rapor Seçimi" :active.sync="isPopupActive" class="text-center">
  <p class="mb-6">Rapor Türünü Seçiniz</p>
  <div class="flex justify-center gap-4">
    <vs-button color="primary" type="filled" @click="getExcelReport()">Excel</vs-button>
    <vs-button color="primary" type="filled" @click="getLocalReport()">Anlık</vs-button>
  </div>
</vs-popup>


      <div
          slot="header"
          class="w-full flex flex-wrap items-center flex-grow justify-between" style="margin-bottom: 1rem;"
        >
        <global-filter
              ref="filterer"
              :tableOptions="tableOptions"
              :filterOptions="filterOptions"
              :filterChips="filterChips"
              :filterOptionNames="filterOptionNames"
              :isActive="isFilterActive"
              @saveOptions="saveOptions"
              @close="isFilterActive = false"
            />
            <vs-row
              id="panelHeaderRow"
              v-show="!isFilterActive"
              vs-type="flex"
              vs-w="12"
              vs-justify="space-between"
            >
              <vs-col
                id="panel-actions"
                vs-type="flex"
                class="w-auto"
                vs-justify="center"
              >
                <vs-row vs-type="flex" vs-w="12">
                  <vs-col vs-type="flex" vs-w="3.75">
                    <vx-tooltip text="Detaylı Filtereleme" position="top">
                      <vs-button
                        @click="isFilterActive = !isFilterActive"
                        class="panel-action text-warning xlarge-button panel-action-box-shadow"
                        color="transparent"
                        icon-pack="pickicon"
                        icon="icon-pick-filter"
                      >
                      </vs-button>
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col id="filter-chips" vs-type="flex">
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  vs-align="center"
                >
                  <vs-button
                    id="clearFilterButton"
                    v-if="filterChips.length > 0"
                    @click="clearFilter"
                    class="mr-2 bg-white text-danger panel-action-box-shadow"
                    icon-pack="feather"
                    icon="icon-slash"
                    radius
                    color="transparent"
                  />
                  <vs-col
                    vs-type="flex"
                    class="w-auto"
                    v-for="(chip, index) in filterChips"
                    :key="index"
                  >
                    <vs-chip
                      color="white"
                      class="panel-action-box-shadow px-1"
                      @click="removeFilter(chip.col, index)"
                      v-show="chip.value != ''"
                      closable
                    >
                      <vs-row vs-tpye="flex" vs-w="12">
                        <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                          <span class="bold text-xsmaller text-dark">
                            {{ chip.name + " :" }}
                          </span>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          class="w-auto ml-1"
                          vs-align="center"
                        >
                          <feather-icon
                            v-if="chip.value === true"
                            icon="CheckIcon"
                            svgClasses="w-4 h-4 text-primary"
                          />
                          <feather-icon
                            v-else-if="chip.value === false"
                            icon="XIcon"
                          />
                          <span
                            v-else
                            class="weight-600 italic text-xsmaller text-primary"
                          >
                            {{ chip.value }}
                          </span>
                        </vs-col>
                      </vs-row>
                    </vs-chip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col
                id="table-page-size"
                vs-type="flex"
                class="w-auto"
                vs-justify="flex-end"
              >
              </vs-col>
            </vs-row>
            <vs-row
              id="panelHeaderRow"
              v-show="tableActive"
              vs-type="flex"
              vs-w="12"
              vs-justify="space-between"
            >
            <vs-col vs-type="flex" vs-w="6" style="margin-top: 1rem;">
                <vs-input icon-pack="feather" icon="icon-search" v-model="branchNameFilter"
                          placeholder="Şube İsmi Ara"
                          class="bg-white text-dark weight-600 w-full text-small" size="small"/>
              </vs-col>
          </vs-row>
            
      </div>
      <table v-if="tableActive" id="myTable">
        <thead id="tableHeader">
          <tr>
            <th style="width: 150px;">Şube Kodu</th>
            <th class="branch-name">Şube</th>
            <th style="width: 150px" class="text-right">Toplam</th>
            <template v-for="date in dates">
              <th style="width: 150px" class="text-right" :key="date">{{ date }}</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr v-for="branch in uniqueBranches.filter(x=> branchNameFilter === '' || (branchNameFilter != '' && x.branchName.toLocaleLowerCase('tr-TR').includes(branchNameFilter.toLocaleLowerCase('tr-TR'))))" :key="branch.branchName">
            <td style="width: 150px">{{ branch.branchCode }}</td>
            <td class="branch-name">{{ branch.branchName }}</td>
            <td style="width: 150px" class="text-right font-bold" :class="{ 'bg-pistachio': getTotalAmount(branch.branchName) > 0 }">{{ formatAmount(getTotalAmount(branch.branchName)) }}</td>
            <td style="width: 150px" class="text-right" v-for="date in dates" :key="date" :class="{ 'bg-pistachio': getAmountForDate(branch.branchName, date) > 0 }">
              {{ formatAmount(getAmountForDate(branch.branchName, date)) }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="grand-total-row">
            <td style="width: 150px" class="font-bold">GENEL</td>
            <td class="branch-name font-bold">Genel Toplam</td>
            <td class="text-right font-bold text-primary" style="width: 150px; color: rgba(var(--vs-primary), 1) !important;">{{ formatAmount(getGrandTotal()) }}</td>
            <td style="width: 150px" class="text-right font-bold" v-for="date in dates" :key="date">
              {{ formatAmount(getGrandTotalForDate(date)) }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    
</template>

<script>
import GlobalFilter from "../../GlobalFilter";
import {getExcel, getAll} from "@/api/BranchWalletTransaction";
export default {
data(){
    return{
        isFilterActive: false,
        filterOptions: [
          "dateRange"
        ],
        filterOptionNames: [
          "Tarih"
        ],
        filterChips: [],
        tableOptions: {},
        isPopupActive: false,
        dates:[],
        localResult:[],
        uniqueBranches:[],
        tableActive: false,
        branchNameFilter: '',
        branchDataMap: {}
    }
},
components: {
      GlobalFilter
    },
methods: {
  getUniqueBranches() {
  this.uniqueBranches = this.localResult.reduce((uniqueBranches, transaction) => {
    const branch = { branchName: transaction.branchName, branchCode: transaction.branchCode };
    const existingBranch = uniqueBranches.find(b => b.branchName === branch.branchName && b.branchCode === branch.branchCode);

    if (!existingBranch) {
      uniqueBranches.push(branch);
    }

    return uniqueBranches;
  }, []);
},
  getTotalAmount(branchName) {
    const branchData = this.branchDataMap[branchName];
    return branchData ? branchData.total : 0;
  },
  getAmountForDate(branchName, date) {
    const branchData = this.branchDataMap[branchName];
    if (!branchData) return 0;
    const normalizeDate = (d) => d ? d.replace(/[\.\/-]/g, '/') : '';
    const targetDate = normalizeDate(date);
    return branchData.dates[targetDate] || 0;
  },
  getGrandTotalForDate(date) {
    const normalizeDate = (d) => d ? d.replace(/[\.\/-]/g, '/') : '';
    const targetDate = normalizeDate(date);
    let total = 0;
    Object.values(this.branchDataMap).forEach(b => {
      total += b.dates[targetDate] || 0;
    });
    return total;
  },
  getGrandTotal() {
    let total = 0;
    Object.values(this.branchDataMap).forEach(b => {
      total += b.total;
    });
    return total;
  },
  formatAmount(val) {
    if (val === null || val === undefined) return "0,00 ₺";
    return `${val.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
  },
   getDatesInRange(startDate, endDate) {
  const dates = [];
  let currentDate;
  let lastDate;

  if (!startDate) {
    const today = new Date();
    startDate = new Date(today.getFullYear(), today.getMonth(), 1); // Bulunduğumuz ayın ilk günü
  } else {
    startDate = new Date(startDate);
  }

  if (!endDate) {
    endDate = new Date(); // Bugünün tarihi
  } else {
    endDate = new Date(endDate);
  }

  currentDate = startDate;
  lastDate = endDate;

  while (currentDate <= lastDate) {
    const formattedDate = this.formatDate(currentDate);
    dates.push(formattedDate);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}
,
 formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
},
      saveOptions(filterOptions, filterChips) {
        console.log(filterChips);
        this.isFilterActive = false;
        if (_.isEqual(this.tableOptions, filterOptions)) return;
        this.tableOptions = _.cloneDeep(filterOptions);
        this.filterChips = _.cloneDeep(filterChips);
      },
      clearFilter() {
        this.tableOptions = {
          sortBy: "Created",
          sortDirection: "desc",
          pageIndex: 0,
          pageSize: this.itemsPerPage,
          dateRange: {
            startDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
            endDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
          },
          timeRange: {
            startTime: null,
            endTime: null,
          },
          paymentMethod: null,
          extra: null,
          product: null,
          personal: null,
          order: null,
          price: {
            min: null,
            max: null,
          },
          dayReportType:null
        };
        this.filterChips.length = 0;
      },
      removeFilter(col, index) {
        //if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
         this.tableOptions[col] = null;
        this.filterChips.splice(index, 1);
      },
      getExcelReport(){
        getExcel(this.tableOptions).then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Cüzdan Muhasebe Raporu" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
            this.isPopupActive = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      },
      getLocalReport(){
        let startLocalDate = this.tableOptions.dateRange && this.tableOptions.dateRange.startDate ? this.tableOptions.dateRange.startDate.toDateString() : null
        let endLocalDate= this.tableOptions.dateRange && this.tableOptions.dateRange.endDate ? this.tableOptions.dateRange.endDate.toDateString() : null
        this.dates = this.getDatesInRange(startLocalDate, endLocalDate);
        getAll(this.tableOptions).then((res) => {
          if (res && res.status == 200) {
            this.localResult = res.data;
            
            // Build the branchDataMap for O(1) rendering performance and correct separator-independent mapping
            this.branchDataMap = {};
            const normalizeDate = (d) => d ? d.replace(/[\.\/-]/g, '/') : '';
            this.localResult.forEach(t => {
              const bName = t.branchName;
              const dStr = normalizeDate(t.dateString);
              const amount = t.amount || 0;

              if (!this.branchDataMap[bName]) {
                this.branchDataMap[bName] = {
                  total: 0,
                  dates: {}
                };
              }

              this.branchDataMap[bName].total += amount;
              if (!this.branchDataMap[bName].dates[dStr]) {
                this.branchDataMap[bName].dates[dStr] = 0;
              }
              this.branchDataMap[bName].dates[dStr] += amount;
            });

            this.getUniqueBranches();
            console.log(this.localResult);
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Rapor Başarılı !",
            });
            this.isPopupActive = false;
            this.tableActive = true;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      }
    },
    watch: {
      tableOptions: {
        deep: true,
        handler(val) {
          this.$nextTick(() => {
            console.log(this.tableOptions);
            this.isPopupActive = true;
            
            //this.getExcelReport();
          });
        },
      }
    }
}
</script>

<style>
#myTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 1rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
  display: block;
  overflow: auto;
  max-height: calc(100vh - 265px);
  white-space: nowrap;
  border: 1px solid #ededed;
}

#myTable th {
  background-color: #f8f8f8;
  color: #626262;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #ededed;
  padding: 12px 16px;
  position: sticky;
  top: 0;
  z-index: 10;
}

#myTable td {
  padding: 12px 16px;
  font-size: 0.9rem;
  color: #2c2c2c;
  border-bottom: 1px solid #ededed;
}

#myTable tbody tr:hover {
  background-color: rgba(184, 149, 108, 0.05);
}

#myTable tbody tr:last-child td {
  border-bottom: none;
}

#myTable tfoot tr {
  background-color: #f8f8f8;
  font-weight: bold;
}

#myTable tfoot td {
  border-top: 2px solid #ededed;
  border-bottom: none;
  font-weight: 700;
  color: #1e1e1e;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  z-index: 9;
}

.text-right {
  text-align: right !important;
}

.font-bold {
  font-weight: bold;
}

.branch-name {
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bg-pistachio {
  background-color: rgba(40, 199, 111, 0.15) !important;
}
</style>